import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Panel, Button, Col, Row } from 'react-bootstrap';
import { Input, FormActions, Checkbox } from '../../common/components/formControls';
import TermsDropdownList from '../terms/DropdownList';
import CentersDropdownList from '../centers/DropdownList';
import { withTranslation } from 'react-i18next';
import ui from '../../common/services/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

const Filter = ({ handleSubmit, onReset, initialize, loading, grades, workWithKindergarten, t }) => {
	const handleReset = () => {
		initialize({});
		onReset();
	};
	return (
		<Panel>
			<Panel.Heading><FontAwesomeIcon icon={faFilter} />{t('Common_Filter')}</Panel.Heading>
			<Panel.Body>
				<form onSubmit={handleSubmit}>
					<Row>
						<Col sm={6}>
							<CentersDropdownList render='field' name='centerId' label={t('Price_Center')} />
						</Col>
						<Col sm={6}>
							<Field name='gradeId' component={Input} componentClass='select' label={t('Price_Grade')} >
								<option />
								{ui.makeOptionValues(grades)}
							</Field>
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<TermsDropdownList render='field' name='termId' label={t('Price_Term')} />
						</Col>
						<Col sm={6}>
							<Field name='pricePerLesson' component={Input} type='text' label={t('Price_PricePerLesson')} />
						</Col>
					</Row>
					{workWithKindergarten && <Row>
						<Col sm={6}>
							<Field name='includeKindergarten' component={Checkbox} label={t('Price_IncludeKindergarten')} normalize={(v) => { return !!v }} />
						</Col>
					</Row>}
					<FormActions>
						<Button type='submit' disabled={loading} bsStyle='primary'>{t('Common_Filter')}</Button>
						<Button disabled={loading} onClick={handleReset}>{t('Common_Reset')}</Button>
					</FormActions>
				</form>
			</Panel.Body>
		</Panel>
	);
};

Filter.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'pricesFilter' })(withTranslation()(Filter));